import { t as w } from "./isDefined-fMi6eQ4r.js";
import { clsx as b } from "clsx";
import { jsx as y } from "react/jsx-runtime";
import { Collapsible as v } from "@base-ui/react/collapsible";
import { useRef as A } from "react";
import { useRender as z } from "@base-ui/react/use-render";
import { DirectionProvider as E, useDirection as H } from "@base-ui/react/direction-provider";
import { mergeProps as T } from "@base-ui/react/merge-props";
import { clamp as I } from "@base-ui/utils/clamp";
import { useControlled as K } from "@base-ui/utils/useControlled";
var L = "_panel_1a8sy_1", V = "_contained_1a8sy_25", D = {
  panel: L,
  contained: V
}, B = ({ children: r, isExpanded: a, dimension: s = "height", animationDurations: o = "default", containAnimation: n = !0, duration: i }) => {
  const l = o === "default" ? void 0 : {
    "--animated-expandable-opacity-duration": `${o.opacity}s`,
    "--animated-expandable-size-duration": `${o.size}s`
  };
  return /* @__PURE__ */ y(v.Root, {
    open: a,
    children: /* @__PURE__ */ y(v.Panel, {
      className: b(D.panel, n && D.contained),
      "data-dimension": s,
      "data-duration": i,
      style: l,
      children: r
    })
  });
}, P = {
  value: 150,
  min: 50,
  max: 500,
  step: 10
}, N = ({ axis: r, value: a, onValueChange: s, min: o, max: n, step: i, disabled: l }) => {
  const c = H(), p = r === "x" && c === "rtl", d = A(null), _ = (e) => {
    l || e.defaultPrevented || e.button !== 0 || w(d.current) || (e.preventDefault(), e.currentTarget.focus?.(), e.currentTarget.setPointerCapture?.(e.pointerId), d.current = {
      pointerId: e.pointerId,
      startPosition: r === "y" ? e.clientY : e.clientX,
      startValue: a
    });
  }, h = (e) => {
    const t = d.current;
    if (l || e.defaultPrevented || !w(t) || t.pointerId !== e.pointerId) return;
    const f = ((r === "y" ? e.clientY : e.clientX) - t.startPosition) * (p ? -1 : 1);
    s(I(t.startValue + f, o, n));
  }, u = (e) => {
    d.current?.pointerId === e.pointerId && (d.current = null, e.currentTarget.hasPointerCapture?.(e.pointerId) && e.currentTarget.releasePointerCapture?.(e.pointerId));
  };
  return {
    onPointerDown: _,
    onPointerMove: h,
    onPointerUp: u,
    onPointerCancel: u,
    onLostPointerCapture: u,
    onKeyDown: (e) => {
      if (l || e.defaultPrevented) return;
      const t = r === "y" ? "ArrowDown" : p ? "ArrowLeft" : "ArrowRight", f = r === "y" ? "ArrowUp" : p ? "ArrowRight" : "ArrowLeft", m = (/* @__PURE__ */ new Map([
        [t, a + i],
        [f, a - i],
        ["Home", o],
        ["End", n]
      ])).get(e.key);
      w(m) && (e.preventDefault(), e.stopPropagation(), s(I(m, o, n)));
    }
  };
}, x = "_area_pqu70_1", M = "_bar_pqu70_26", C = {
  area: x,
  bar: M
}, G = ({ axis: r = "y", value: a, defaultValue: s = P.value, onValueChange: o, min: n = P.min, max: i = P.max, step: l = P.step, disabled: c = !1, className: p, children: d, render: _, ref: h, ...u }) => {
  const [R, e] = K({
    controlled: a,
    default: s,
    name: "ResizeHandle"
  }), t = I(R, n, i), m = N({
    axis: r,
    value: t,
    onValueChange: (g) => {
      g !== t && (e(g), o?.(g));
    },
    min: n,
    max: i,
    step: l,
    disabled: c
  });
  return z({
    render: _,
    ref: h,
    state: {
      axis: r,
      disabled: c
    },
    props: T(m, u, {
      role: "separator",
      tabIndex: c ? -1 : u.tabIndex ?? 0,
      "aria-label": u["aria-label"] ?? "Resize",
      "aria-orientation": r === "y" ? "horizontal" : "vertical",
      "aria-valuemin": n,
      "aria-valuemax": i,
      "aria-valuenow": t,
      "aria-disabled": c || void 0,
      className: b(C.area, p),
      children: d ?? /* @__PURE__ */ y("div", { className: C.bar })
    })
  });
}, J = ({ direction: r, children: a }) => /* @__PURE__ */ y(E, {
  direction: r,
  children: a
});
export {
  G as n,
  B as r,
  J as t
};
